import { CalendarCheck, Bot, Contact, FileSignature, Gauge, Mail, Search, UserCog } from 'lucide-react'
import { hasModule } from '../../features/access/modules.js'
import { isAdmin } from '../../features/admin/utils/isAdmin.js'
import { hasUstsAutoProjectAccess } from '../../features/auto-projects/utils/organizationAccess.js'

/**
 * Menu principal (organisation de la maquette « Jean Louis V3 », limitée à ce qui existe).
 * `match` : préfixes d'adresse qui rendent l'entrée active ; `title` / `subtitle` : en-tête de page.
 * Les écrans de la maquette sans back (affaires, objectifs, point du vendredi…) viendront ensuite.
 */
export const NAV_ITEMS = [
  {
    key: 'jour',
    to: '/dashboard',
    label: 'Ma journée',
    icon: CalendarCheck,
    end: true,
    title: 'Ma journée',
    subtitle: 'Vos priorités, vos relances et vos prochaines actions.',
    visible: () => true,
  },
  {
    key: 'prospection',
    to: '/dashboard/prospection',
    match: ['/dashboard/prospection'],
    label: 'Prospection',
    icon: Search,
    title: 'Prospection',
    subtitle: 'Choisissez vos sources et préparez une acquisition ciblée.',
    visible: (user) => ['prospects', 'immobilier', 'france_travail'].some((m) => hasModule(user, m)),
  },
  {
    key: 'communication',
    to: '/dashboard/communication',
    match: ['/dashboard/communication'],
    label: 'Communication',
    icon: Mail,
    title: 'Communication',
    subtitle: 'E-mails, séquences de relance automatiques et suivi des envois.',
    visible: (user) => hasModule(user, 'communication'),
  },
  {
    key: 'offre',
    to: '/dashboard/serge-projects',
    match: ['/dashboard/serge-projects', '/dashboard/contrats'],
    label: 'Offre et contrats',
    icon: FileSignature,
    title: 'Offre et contrats',
    subtitle: 'Projets et livrables, devis, contrats et factures.',
    visible: () => true,
  },
  {
    key: 'clients',
    to: '/dashboard/clients',
    match: ['/dashboard/clients'],
    label: 'Clients',
    icon: Contact,
    title: 'Clients',
    subtitle: 'Vos prospects, contacts et bases issues de la prospection.',
    visible: (user) => ['prospects', 'immobilier', 'france_travail'].some((m) => hasModule(user, m)),
  },
  {
    key: 'projets',
    to: '/dashboard/projets-auto',
    match: ['/dashboard/projets-auto'],
    label: 'Projets auto',
    icon: Bot,
    title: 'Projets auto',
    subtitle: "Les annonces traitées par l'agent Jean-Louis : suivi, attribution et relances.",
    badge: 'newAutoProjects',
    visible: (user) => hasModule(user, 'projects_auto') && hasUstsAutoProjectAccess(user),
  },
  { key: 'sep', separator: true, visible: () => true },
  {
    key: 'pilotage',
    to: '/dashboard/compte/admin',
    match: ['/dashboard/compte/admin'],
    label: 'Pilotage',
    icon: Gauge,
    title: 'Pilotage',
    subtitle: "Statistiques, risques, commissions et activité de l'équipe.",
    visible: (user) => isAdmin(user),
  },
  {
    key: 'compte',
    to: '/dashboard/compte',
    match: ['/dashboard/compte'],
    label: 'Compte',
    icon: UserCog,
    title: 'Compte',
    subtitle: 'Crédits, connexions, entreprises, modèles et organisation.',
    visible: () => true,
  },
]

/** Entrée du menu correspondant à l'adresse (le préfixe le plus long l'emporte). */
export function navItemFor(pathname) {
  const candidates = NAV_ITEMS.filter((item) => !item.separator).flatMap((item) => {
    if (item.end) return pathname === item.to || pathname === `${item.to}/` ? [[item, item.to.length]] : []
    return (item.match || [item.to])
      .filter((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
      .map((prefix) => [item, prefix.length])
  })
  candidates.sort((a, b) => b[1] - a[1])
  return candidates[0]?.[0] ?? null
}
